import React, { Fragment } from 'react'
import { FieldError } from './styles'

export default InputComponent => ({ input, meta: { touched, error }, ...rest }) => (
  <Fragment>
    <InputComponent {...input} hasError={touched && error} {...rest} />
    {touched && error && <FieldError>{error}</FieldError>}
  </Fragment>
)



// WEBPACK FOOTER //
// ./src/Components/FormElements/toFinalFormInput.jsx